import { Link } from 'react-router-dom';
import { useSidebar } from '@strivelabs/ui-blocks/v2';
import { APP_ROUTES } from '@/constants';
import { useCurrentTheme } from '@/hooks/useTheme';

/**
 * The brand, linking home: the full lockup (mark + wordmark) when expanded,
 * the mark alone in the rail. Both come from the active theme so white-label
 * brands render their own. Labelled with the brand name rather than "Home" so
 * it does not collide with the Home nav item — two links sharing one
 * accessible name is ambiguous to a screen reader.
 */
export function SidebarBrand() {
  const { name, assets } = useCurrentTheme();
  const { collapsed } = useSidebar();

  return (
    <Link
      to={APP_ROUTES.HOME}
      aria-label={name}
      className="flex h-10 min-w-0 items-center rounded-v2-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-v2-sidebar-ring"
    >
      {collapsed ? (
        <img src={assets.navbarLogo} alt="" className="h-[26px] w-auto shrink-0 object-contain" />
      ) : (
        <img src={assets.fullLogo} alt="" className="h-7 w-auto max-w-full shrink-0 object-contain" />
      )}
    </Link>
  );
}
